import React, { useState, useEffect } from "react";
import { Button, Menu, Layout } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

const { Header } = Layout;

const HeaderComponent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTab(width > 768 && width <= 1024);
      if (width > 1024) {
        setIsMenuOpen(false);
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
  {
    key: "home",
    label: <Link to="/">Home</Link>,
  },
  {
    key: "features",
    label: <Link to="/features">Features</Link>,
  },
  {
    key: "pricing",
    label: <Link to="/pricing">Pricing</Link>,
  },
  {
    key: "contact",
    label: <Link to="/contact">Contact</Link>,
  },
];


  const handleMenuClick = (e) => {
    console.log("Menu item clicked:", e.key);
    setIsMenuOpen(false); // Close menu after clicking
    if (e.key === "pricing") {
      navigate(`/pricing`);
    } else if (e.key === "features") {
      navigate(`/features`);
    } else if (e.key === "contact") {
      navigate(`/contact`);
    } else {
      navigate(`/`);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Styles
  const headerStyle = {
    textAlign: "center",
    color: "#fff",
    height: 64,
    paddingInline: isMobile ? 18 : (isTab ? 50 : 110),
    lineHeight: "64px",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  };

  const logoStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#fff",
    width: isMobile ? "100px" : "120px",
    height: isMobile ? "40px" : "50px",
  };

  const menuStyle = {
    backgroundColor: "transparent",
    fontWeight: "bold",
    border: "none",
    color: "#fff",
    flex: 1,
    justifyContent: "flex-end",
    paddingRight: isTab ? "20px" : "45px",
    display: (isMobile || isTab) ? "none" : "flex",
  };

  const menuButtonStyle = {
    display: (isMobile || isTab) ? "flex" : "none",
    fontSize: "24px",
    color: "#fff",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    padding: 0,
  };

  const buttonsContainerStyle = {
    display: "flex",
    gap: "8px",
  };

  const mobileButtonsContainerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "16px",
  };

  const mobileMenuStyle = {
    backgroundColor: "#000",
    fontWeight: "bold",
    border: "none",
    color: "#fff",
    display: (isMobile || isTab) && isMenuOpen ? "block" : "none",
    position: "absolute",
    top: "64px",
    left: 0,
    right: 0,
    zIndex: 1000,
  };

  return (
    <Header style={headerStyle}>
      <img src={require("../../assets/images/footerlogo.png")} alt="Optix360" style={logoStyle} />
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={toggleMenu}
        style={menuButtonStyle}
      />
      <Menu
        mode="horizontal"
        items={menuItems}
        onClick={handleMenuClick}
        style={menuStyle}
        theme="dark"
        inlineCollapsed={false}
      />
      {!(isMobile || isTab) ? (
        <div style={buttonsContainerStyle}>
          <Button type="text" style={{ color: "#fff", borderColor: "#fff", width: "120px" }}
          onClick={() => window.location.href = "https://optix360-app.mayaartech.com/login"}>
            Login
          </Button>
          <Button
            type="primary"
            style={{
              backgroundColor: "#fff",
              color: "#111827",
              borderColor: "#fff",
              width: "150px"
            }}
            onClick={() => window.location.href = "https://optix360-app.mayaartech.com/signup"}
          >
            Register
          </Button>
        </div>
      ) : null}
      {(isMobile || isTab) && isMenuOpen && (
        <div style={mobileMenuStyle}>
          <Menu
            mode="vertical"
            items={menuItems}
            onClick={handleMenuClick}
            style={{ backgroundColor: "#000", border: "none" }}
            theme="dark"
            inlineCollapsed={false}
          />
          <div style={mobileButtonsContainerStyle}>
            <Button type="text" 
            style={{ color: "#fff", borderColor: "#fff", width: "100%" }}
             onClick={() => window.location.href = "https://optix360-app.mayaartech.com/login"}
            >
              Login
            </Button>
            <Button
              type="primary"
              style={{
                backgroundColor: "#fff",
                color: "#111827",
                borderColor: "#fff",
                width: "100%"
              }}
              onClick={() => window.location.href = "https://optix360-app.mayaartech.com/signup"}
            >
              Register
            </Button>
          </div>
        </div>
      )}
    </Header>
  );
};

export default HeaderComponent;